import React from 'react';

import { EntitiesCardTitle } from '../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleText } from '../../components/entities-card/EntitiesTitleText';

export const LegislationCardTitleText: React.FC = ({ children }) => (
  <EntitiesCardTitle>
    <EntitiesTitleText>{children}</EntitiesTitleText>
  </EntitiesCardTitle>
);
